import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Legal page for music usage terms.
 * Public, no login. Accessible only via direct link /legal.
 * Dark (black) layout, legal copy in English.
 */
export function LegalMusicPage() {
  return (
    <div className="min-h-screen w-full bg-black text-neutral-200">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <header className="mb-10 border-b border-white/10 pb-8">
          <h1 className="text-2xl font-semibold tracking-tight text-white sm:text-3xl">
            Terms of Use for Musical Content
          </h1>
          <p className="mt-2 text-sm text-neutral-400">
            Dark Torus / darktorus.com · Last updated: 15 February 2026
          </p>
        </header>

        <main className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              1. Rightsholder and Nature of Works
            </h2>
            <p className="text-neutral-300">
              All musical content available on the Dark Torus website (darktorus.com) and in related
              applications and services is created and owned by Dark Torus (“we”, “rightsholder”).
              Such music consists of original works produced by us. Exclusive rights in these works
              belong to Dark Torus.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              2. Permitted Use
            </h2>
            <p className="text-neutral-300">
              Music is provided solely for personal, non-commercial listening within the service
              (including the breathing screen with 3D torus and other modes offered in the interface).
              Use is permitted only by means of streaming playback through our website or application,
              without saving or copying files.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              3. Prohibited Uses
            </h2>
            <ul className="list-inside list-disc space-y-2 text-neutral-300">
              <li>
                <strong className="text-neutral-200">Downloading.</strong> Downloading, saving,
                or otherwise copying audio files and musical content is prohibited. We do not
                provide the ability for end users to download music.
              </li>
              <li>
                <strong className="text-neutral-200">Resale and commercial use.</strong>{' '}
                Music may not be resold, transferred to third parties for commercial purposes, or
                used in commercial products, advertising, podcasts, streams, or the like without
                prior written consent from Dark Torus.
              </li>
              <li>
                <strong className="text-neutral-200">Distribution.</strong> Distribution,
                publication, transfer, or placement of our musical content on other sites, platforms,
                or media without the rightsholder’s permission is prohibited.
              </li>
              <li>
                <strong className="text-neutral-200">Alteration and misappropriation.</strong>{' '}
                Removing or altering copyright notices and metadata, or presenting the works as
                one’s own or as belonging to third parties, is prohibited.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              4. Disclaimer
            </h2>
            <p className="text-neutral-300">
              Music is provided “as is”. Dark Torus gives no warranties of fitness for any
              particular purpose. Use of the service and content is at your own risk.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              5. Changes to Terms
            </h2>
            <p className="text-neutral-300">
              We may change these terms at any time. The current version is always available on
              this page. Continued use of the service after changes are published constitutes
              acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-lg font-medium text-white">
              6. Contact
            </h2>
            <p className="text-neutral-300">
              For licensing, permission to use the music, or other legal inquiries, contact
              Dark Torus via the official website darktorus.com.
            </p>
          </section>

          <footer className="mt-12 border-t border-white/10 pt-8">
            <p className="text-xs text-neutral-500">
              © Dark Torus. All rights reserved. darktorus.com
            </p>
            <Link
              to="/"
              className="mt-4 inline-block text-sm text-neutral-400 underline underline-offset-2 hover:text-white"
            >
              ← Back to home
            </Link>
          </footer>
        </main>
      </div>
    </div>
  );
}
